// Legacy/macro-enabled↔modern office-format equivalence for upload de-duplication.
// The backend canonicalises .doc→.docx and .xls/.xlsm→.xlsx on ingest (clean_file /
// allocate_file / triage_file via normalize_upload), so the same logical file
// uploaded in any of these extensions is the same file and must be caught by the
// duplicate-name check.
const EQUIVALENT_EXT_GROUPS = [
  ['doc', 'docx'],
  ['xls', 'xlsx', 'xlsm'],
];

// The set of equivalent filenames to test against: the name itself plus every
// other member of its extension group when it belongs to one. Always non-empty.
export function nameVariants(fileName) {
  const name = fileName || '';
  const dot = name.lastIndexOf('.');
  if (dot < 0) return [name];
  const ext = name.slice(dot + 1).toLowerCase();
  const group = EQUIVALENT_EXT_GROUPS.find((g) => g.includes(ext));
  if (!group) return [name];
  const base = name.slice(0, dot);
  return [name, ...group.filter((g) => g !== ext).map((g) => `${base}.${g}`)];
}

// Accepted upload file types, shared by the direct (ProfileDashboard) and smart
// (SmartUploadFiles) upload funnels. .csv is intentionally excluded — the segmenter
// has no csv container path (it raises on one).
export const ACCEPTED_UPLOAD_EXTENSIONS = ['.xlsx', '.xls', '.xlsm', '.pdf', '.docx', '.doc'];

export const isAcceptedUpload = (name) =>
  ACCEPTED_UPLOAD_EXTENSIONS.some((ext) => (name || '').toLowerCase().endsWith(ext));

// Maximum upload size, enforced three times: here (friendly pre-check), in
// storage.rules (authoritative for the client surface), and in the backend's
// validate_file_content (defence in depth). Keep the three in sync by hand.
export const MAX_UPLOAD_BYTES = 50 * 1024 * 1024;
export const MAX_UPLOAD_LABEL = '50MB';

// The most files one selection may hold, on every route in — the workspace
// zone, a table bucket, a table's Smart Upload and a profile's upload — so the
// limit does not depend on where the files were dropped.
export const MAX_UPLOAD_FILES = 60;
export const MAX_UPLOAD_FILES_MESSAGE = `You can only upload up to ${MAX_UPLOAD_FILES} files at once.`;
export const MAX_UPLOAD_FILES_CHIP = `Too many files — up to ${MAX_UPLOAD_FILES}`;

// A staging file's proposal is decisive only when the allocator found ONE best
// profile. A tie (`tied_profile_ids` holds every equally matched profile) is
// the person's to resolve: nothing is preselected and nothing bulk-approves
// until they choose.
export const isTiedAllocation = (file) => (file?.tied_profile_ids || []).length > 1;
export const effectiveProfileId = (file) => (
  file?.selected_data_profile || (isTiedAllocation(file) ? null : file?.proposed_data_profile) || null
);
